export const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

export const getPastDate = (date, months, days) => {
    const currentDate = new Date(date);

    const pastDate = new Date(Date.UTC(
        currentDate.getUTCFullYear(),
        currentDate.getUTCMonth() - months,
        currentDate.getUTCDate()
    ));

    pastDate.setUTCDate(pastDate.getUTCDate() - days);

    return toDateOnly(pastDate);
};

export const getFullMonthsAndDays = (startDate, endDate) => {
    const start = new Date(startDate);
    const end = new Date(endDate);

    const totalDays = Math.ceil((end - start) / (1000 * 60 * 60 * 24)) + 1;

    let months = 0;
    let monthDays = 0;

    let current = new Date(start);

    if (current.getUTCDate() !== 1) {
        current.setUTCMonth(current.getUTCMonth() + 1);
    }

    current = new Date(Date.UTC(current.getUTCFullYear(), current.getUTCMonth() + 1, 0));

    const datesByFullMonth = {}

    while (current <= end) {
        if (!(
            current.getUTCFullYear() < end.getUTCFullYear() ||
            (current.getUTCFullYear() === end.getUTCFullYear() &&
                current.getUTCMonth() < end.getUTCMonth()) ||
            (current.getUTCFullYear() === end.getUTCFullYear() &&
                current.getUTCMonth() === end.getUTCMonth() &&
                current.getUTCDate() <= end.getUTCDate())
        )) {
            break;
        }

        months++;

        const key = `${current.getUTCFullYear()}-${(current.getUTCMonth() + 1).toString().padStart(2, '0')}`
        datesByFullMonth[key] = {
            start: `${key}-01`,
            end: `${key}-${current.getUTCDate()}`,
        }

        monthDays += current.getUTCDate();
        current = new Date(Date.UTC(current.getUTCFullYear(), current.getUTCMonth() + 2, 0));
    }

    const days = totalDays - monthDays;

    return { months, days, datesByFullMonth };
};

export const getPriorRange = (startDate, endDate) => {
    const startDay = startDate.split('-')[2]
    const endDay = endDate.split('-')[2]

    const startYear = startDate.split('-')[0]
    const endYear = endDate.split('-')[0]

    const numberOfYearsToGoBack = (endYear - startYear) == 0 ? 1 : (endYear - startYear)

    const startMonth = startDate.split('-')[1]
    const endMonth = endDate.split('-')[1]

    return {
        priorStartDate: `${startYear - numberOfYearsToGoBack}-${startMonth.toString().padStart(2, '0')}-${startDay}`,
        priorEndDate: `${endYear - numberOfYearsToGoBack}-${endMonth.toString().padStart(2, '0')}-${endDay}`
    }
}

export const getPeriod = (date) => {
    const year = date.split('-')[0]
    const month = date.split('-')[1]

    return `${year}-${month}`
}

export const toDateOnly = (date) => {
    return new Date(date).toISOString().split('T')[0];
}

export const getMonthsInRange = (start, end) => {
    // Extract start and end year and month
    const [startYear, startMonth] = start.split('-').map(Number);
    const [endYear, endMonth] = end.split('-').map(Number);

    const months = [];

    // If the start year is the same as the end year
    if (startYear === endYear) {
        for (let month = startMonth; month <= endMonth; month++) {
            months.push(month);
        }
    } else {
        // Loop through from start month to the end of the start year
        for (let month = startMonth; month <= 12; month++) {
            months.push(month);
        }

        // Loop through the full years between start and end years
        for (let year = startYear + 1; year < endYear; year++) {
            for (let month = 1; month <= 12; month++) {
                months.push(month);
            }
        }

        // Loop through from January to the end month of the end year
        for (let month = 1; month <= endMonth; month++) {
            months.push(month);
        }
    }

    return months;
}

export const getMonthAndQuarterByStartAndEndPeriod = (startPeriod, endPeriod) => {
    const monthsBetween = new Set(getMonthsInRange(startPeriod, endPeriod))

    const toReturn = {
        months: [],
        quarters: new Set()
    }

    monthsBetween.forEach(m => {
        toReturn.months.push(MONTHS[m - 1])
        toReturn.quarters.add(`Q${Math.ceil(m / 3)}`)
    })

    return {
        months: toReturn.months,
        quarters: [...toReturn.quarters]
    }
}

export const getLast12MonthsRange = (date) => {
    const [year, month] = date.split('-').map(v => parseInt(v));

    const totalMonths = (year * 12) + month - 1;
    const newTotalMonths = totalMonths - 11;
    const lastYear = Math.floor(newTotalMonths / 12);
    const newMonth = newTotalMonths % 12 + 1;

    return {
        startDate: `${lastYear}-${newMonth.toString().padStart(2, '0')}`,
        endDate: `${year}-${month.toString().padStart(2, '0')}`,
    }
};
